import { ScrollReveal } from '@/components/ui/scroll-reveal';
import { FormContact } from '@/components/forms/FormContact';

export function ContactSection() {
  return (
    <section id="contact" className="relative py-28 bg-charcoal-deep overflow-hidden">
      <div
        className="absolute top-0 right-0 w-1/2 h-full pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at right, rgba(0,180,216,.1), transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16">
        <ScrollReveal direction="left">
          <div className="text-electric font-display tracking-[0.4em] text-xs mb-4">// DROP THE BOOM</div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mb-8">
            TALK TO <span className="text-thunder">THUNDER.</span>
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-10">
            Fill out the form. A team member responds within one business hour. Or skip the form and just call — a human picks up.
          </p>

          <div className="space-y-6">
            <a href="tel:4074616039" className="flex items-center gap-5 group">
              <div className="w-14 h-14 border-2 border-electric flex items-center justify-center text-electric text-xl group-hover:bg-electric group-hover:text-charcoal-deep transition skew-card">
                <span className="skew-inner">&#x2706;</span>
              </div>
              <div>
                <div className="font-display text-electric tracking-[0.3em] text-xs">PHONE</div>
                <div className="font-display text-white text-2xl group-hover:text-thunder transition">(407) 461-6039</div>
              </div>
            </a>

            <a href="mailto:dalvarez@sotsvc.com" className="flex items-center gap-5 group">
              <div className="w-14 h-14 border-2 border-electric flex items-center justify-center text-electric text-xl group-hover:bg-electric group-hover:text-charcoal-deep transition skew-card">
                <span className="skew-inner">&#x2709;</span>
              </div>
              <div>
                <div className="font-display text-electric tracking-[0.3em] text-xs">EMAIL</div>
                <div className="font-display text-white text-xl sm:text-2xl group-hover:text-thunder transition break-all">
                  dalvarez@sotsvc.com
                </div>
              </div>
            </a>

            <div className="flex items-center gap-5">
              <div className="w-14 h-14 border-2 border-electric flex items-center justify-center text-electric text-xl skew-card">
                <span className="skew-inner">&#x26B2;</span>
              </div>
              <div>
                <div className="font-display text-electric tracking-[0.3em] text-xs">BASE</div>
                <div className="font-display text-white text-2xl">Altamonte Springs, FL</div>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="right">
          <FormContact />
        </ScrollReveal>
      </div>
    </section>
  );
}
